import { captureExceptionWithExtra } from 'error_tracker';
/**
 * SKU format needs to match SAS feed:
 * sub products: <store_id>_<subscription_type_term_id>_<renewing_type>
 * one-time, gift cards: <store_id>_<product_instance_id>
 *
 * @param {Number} storeId - store.id
 * @param {Object} subscriptions - Array of Subscription objects
 * @param {Object} products - Array of CartProduct objects
 * @return {String} skuList - Comma-separated list of product SKUs
 */
function _getSkuList(storeId, subscriptions=[], products=[]) {
	const subSkuList = subscriptions.reduce((skus, sub) => {
		if (sub.term.id) {
			const renewingStr = sub.autorenew ? 'renewing' : 'nonrenewing';
			skus.push(`${storeId}_${sub.term.id}_${renewingStr}`);
		}
		return skus;
	}, []);

	var nonSubSkuList = products.reduce((skus, cp) => {
		if (!cp.subscriptionTypeTermId) {
			skus.push(`${storeId}_${cp.productInstanceId}`);
		}
		return skus;
	}, []);

	const skuList = subSkuList.concat(nonSubSkuList).join(',');
	return skuList;
}

function _buildShareasalePixelUrl(order, cart) {
	if (!order || !cart) return;

	const products = cart.products;
	const coupons = cart.coupons;
	const storeId = order.storeId;
	const subscriptions = order.subscriptions;
	const skuList = _getSkuList(storeId, subscriptions, products);
	const quantityList = products.map((p) => p.quantity).join(',');
	const priceList = products.map((p) => ((p.price * 0.01) / p.quantity)).join(',');
	const couponList = coupons.map((c) => c.code_used).join(',');
	const isNewCustomer = order?.returningStatus === "returning" ? 0 : 1;
	const orderTotal = order.total * 0.01;

	const sasTrackingArgs = order.id +
		"&amount=" + parseFloat(orderTotal).toFixed(2) +
		"&skulist=" + skuList +
		"&quantitylist=" + quantityList +
		"&pricelist=" + priceList +
		"&merchantID=92473&transtype=sale" +
		"&currency=" + order.currencyCode +
		"&couponcode=" + couponList +
		"&newcustomer=" + isNewCustomer;

	if (window?.cj?.environment === "dev") {
		console.log(`ShareASale tracking args: ${sasTrackingArgs}`);
		return;
	}

	return `https://www.shareasale.com/sale.cfm?tracking=${sasTrackingArgs}`;
}

/**
 * Build & return ShareASale URL
 *
 * @param {Object} order - Order object
 * @param {Object} cart - Cart object
 * @return {String} shareasaleUrl
 */
export default function getShareasalePixelUrl(order, cart) {
	try {
		// Any problems here whatsoever and we just skip
		return _buildShareasalePixelUrl(order, cart);
	} catch (e) {
		console.warn('Cound not determine SAS URL', e);
		captureExceptionWithExtra('Cound not determine SAS URL', e);
		return;
	}
}
